import {useCallback, useEffect, useState} from 'react';
import {getSkuStockEvidence} from '../http/catalogApi';
import {adminProductId, normalizeAdminStockEvidence} from '../utils/adminStockEvidence';

const pending = productId => ({productId, mode: 'unknown', status: 'loading', evidence: null});

export default function useAdminStockEvidence(productId, refreshKey = 0) {
  const id = adminProductId(productId);
  const [state, setState] = useState(() => pending(id));
  const [refreshCount, setRefreshCount] = useState(0);
  const refresh = useCallback(() => setRefreshCount(count => count + 1), []);

  useEffect(() => {
    let active = true;
    const controller = new AbortController();
    setState(previous => ({...pending(id), mode: previous.productId === id ? previous.mode : 'unknown'}));
    if (id === null) {
      setState({...pending(id), status: 'error'});
      return () => {active = false; controller.abort();};
    }
    getSkuStockEvidence(id, {signal: controller.signal})
      .then(payload => {
        const normalized = normalizeAdminStockEvidence(payload, id);
        if (active) setState({...normalized, status: 'ready'});
      })
      .catch(() => {
        if (active) setState(previous => ({...pending(id), status: 'error',
          mode: previous.productId === id && previous.mode === 'admin' ? 'admin' : 'unknown'}));
      });
    return () => {active = false; controller.abort();};
  }, [id, refreshKey, refreshCount]);

  // Block the old product immediately, before its effect cleanup has run.
  return {...(state.productId === id ? state : pending(id)), refresh};
}
